import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import {
  COLOR_BLACK,
  COLOR_BLACK_TRANSPARENT,
  COLOR_CORAL,
  COLOR_ERROR,
  COLOR_GREY100,
  COLOR_GREY200,
  COLOR_GREY400,
  COLOR_GREY_3,
  COLOR_LIGHT_BLUE,
  COLOR_SECONDARY_MAIN,
  COLOR_WHITE,
} from "shared/theme/colors";
import { border } from "shared/theme/mixins";

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (propName) =>
    !["charactersLimit", "isCharactersLimitError"].includes(propName),
})<{
  charactersLimit?: number;
  isCharactersLimitError: boolean;
}>`
  display: flex;
  position: relative;

  .MuiInputLabel-root {
    &.MuiInputLabel-shrink {
      position: relative;
      transform: none;
      transform-origin: inherit;
      margin-bottom: 0.5rem;
      font-size: 12px;
    }
  }

  &.Mui-focused {
    color: ${COLOR_CORAL};
  }

  .MuiOutlinedInput-root {
    padding: 0;

    input[type="password"] {
      padding: 0 3.5rem 0 1rem;
    }

    &.Mui-focused {
      color: ${COLOR_GREY400};
      background-color: ${COLOR_WHITE};

      .MuiOutlinedInput-notchedOutline {
        ${border(2, COLOR_LIGHT_BLUE)}
        padding: 0 calc(1rem - 1px);
        box-shadow: ${COLOR_BLACK_TRANSPARENT(0.05)} 0 0 0 4px;
        border-radius: 0.5rem;
      }

      textarea.MuiOutlinedInput-input {
        padding: 1rem 1rem
          ${({ charactersLimit }) => (charactersLimit ? 2 : 1)}rem;
      }
    }

    .MuiOutlinedInput-input {
      font-size: 14px;
      color: ${({ isCharactersLimitError }) =>
        isCharactersLimitError ? COLOR_ERROR : COLOR_BLACK};
      border-radius: 0.5rem;
      height: ${({ size }) => (size === "small" ? "40px" : "48px")};
      padding: 0 1rem;
      box-shadow: rgba(115, 125, 255, 0) 0 0 0 4px;
      transition: box-shadow 0.3s;
      background-color: ${COLOR_WHITE};
      ${border(1, COLOR_GREY100)};

      ::placeholder {
        color: ${COLOR_GREY200};
        opacity: 1;
      }
    }

    textarea.MuiOutlinedInput-input {
      padding: 1rem 1rem
        ${({ charactersLimit }) => (charactersLimit ? 2 : 1)}rem;
    }

    &.Mui-error {
      .MuiOutlinedInput-notchedOutline {
        ${border(2, COLOR_SECONDARY_MAIN)};
        box-shadow: none;
        border-radius: 0.5rem;
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border: unset;
    }

    &.Mui-disabled {
      .MuiOutlinedInput-input {
        background-color: ${COLOR_GREY_3};
      }
    }
  }
`;

export const StyledPasswordAdornment = styled(Box)`
  position: absolute;
  right: 0.75rem;

  .MuiInputAdornment-root {
    margin-left: 0;
  }
`;

export const StyledIconButton = styled(IconButton)`
  padding: 4px;
`;

export const StyledCharactersCounter = styled(Box)`
  position: absolute;
  bottom: 0.625rem;
  right: 0.625rem;
`;
